$(window).on("show.bs.modal", (modalEvent: any) => {
    modalEvent.target.removeAttribute("aria-hidden")
    modalEvent.target.setAttribute("tabindex", "0")
    document.querySelector("main")?.setAttribute("aria-hidden", "true")
    trapFocus(modalEvent.target)
})

$(window).on("hide.bs.modal", (modalEvent: any) => {
    clearTrapFocus()
    document.querySelector("main")?.removeAttribute("aria-hidden")
    modalEvent.target.setAttribute("aria-hidden", "true")
    modalEvent.target.setAttribute("tabindex", "-1")
})

// https://github.com/unovue/reka-ui/blob/v2/packages/core/src/shared/trap-focus.ts
let currentFocusListener: ((e: KeyboardEvent) => void) | null = null
let currentElementListener: HTMLElement | null = null
export function trapFocus(element: HTMLElement) {
    if (element) {
        clearTrapFocus()

        const focusableEls = [
            ...Array.from(
                element.querySelectorAll(
                    'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])',
                ),
            ),
        ].filter((el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden"))
        const firstFocusableEl = focusableEls[0] as HTMLElement
        const lastFocusableEl = focusableEls[focusableEls.length - 1] as HTMLElement
        const KEYCODE_TAB = 9

        if (firstFocusableEl) firstFocusableEl.focus()

        currentFocusListener = (e: KeyboardEvent) => {
            const isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB

            if (!isTabPressed) return

            if (e.shiftKey) {
                /* shift + tab */ if (getActiveElement() === firstFocusableEl) {
                    lastFocusableEl.focus()
                    e.preventDefault()
                }
            } else {
                /* tab */
                if (getActiveElement() === lastFocusableEl) {
                    firstFocusableEl.focus()
                    e.preventDefault()
                }
            }
        }
        element.addEventListener("keydown", currentFocusListener)
        currentElementListener = element
        return firstFocusableEl
    }
}

export function clearTrapFocus() {
    if (currentFocusListener && currentElementListener) {
        currentElementListener.removeEventListener("keydown", currentFocusListener)
    }
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur()
    }
}

// https://github.com/unovue/reka-ui/blob/v2/packages/core/src/shared/getActiveElement.ts
export function getActiveElement(): Element | null {
    let activeElement = document.activeElement
    if (activeElement == null) {
        return null
    }

    while (
        activeElement != null &&
        activeElement.shadowRoot != null &&
        activeElement.shadowRoot.activeElement != null
    ) {
        activeElement = activeElement.shadowRoot.activeElement
    }

    return activeElement
}
